export default class MobileTooltip {
	private showTooltipIcons: NodeListOf<HTMLElement>;

	constructor(targets: NodeListOf<HTMLElement>) {
		this.showTooltipIcons = targets;

		this.showTooltipIcons.forEach((icon) =>
			icon.addEventListener('click', this.updateTooltips)
		);
	}

	private updateTooltips = (event: Event) => {
		event.stopPropagation();
		event.preventDefault();

		const target: HTMLElement = event.currentTarget as HTMLElement;

		if (target.classList.contains('active')) {
			document.body.removeEventListener('click', this.hideAllTooltips);
			target.classList.remove('active');
		} else {
			document.body.addEventListener('click', this.hideAllTooltips);
			this.hideAllTooltips();
			target.classList.add('active');
		}
	};

	private hideAllTooltips = () => {
		this.showTooltipIcons.forEach((icon) => icon.classList.remove('active'));
	};
}
